"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.playersProviderActions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const _reduxjs_1 = require("../../utils/@reduxjs");
const api_1 = require("../../utils/api");
const REDUCER_KEY = 'playersProvider';
exports.initialState = (0, _reduxjs_1.getPreloadedState)(REDUCER_KEY, {
    players: {
        entries: {},
        fetchItems: api_1.requestInitialState,
    },
});
const playersProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchPlayers(state, _action) {
            state.players.fetchItems.loading = true;
            state.players.fetchItems.error = null;
        },
        fetchPlayersStopped(state) {
            state.players.fetchItems.loading = false;
        },
        fetchPlayersSuccess(state, action) {
            state.players.entries = {
                ...state.players.entries,
                ...(0, _reduxjs_1.toIdsMap)(action.payload.players),
            };
            state.players.fetchItems.loading = false;
            state.players.fetchItems.error = null;
        },
        fetchPlayersError(state, action) {
            state.players.fetchItems.loading = false;
            state.players.fetchItems.error = action.payload;
        },
    },
});
exports.playersProviderActions = playersProviderSlice.actions, exports.reducer = playersProviderSlice.reducer, exports.sliceKey = playersProviderSlice.name;
//# sourceMappingURL=slice.js.map